export interface RemarksDTO {
  code: string;
  provider_id: number;
  provider_tier: string;
  description: string;
  provider: string;
  line: string;
  issue_reason: string;
  actions: string;
  impact_percentage: number;
  logistics_flow: string;
  report_date: string;
  id: number;
  created_at: string | null;
  modified_at: string | null;
}

export class RemarksListDTO {
  constructor(public data: RemarksDTO[]) {}
}

export type CreateRemarkDTO = Omit<RemarksDTO, 'id' | 'report_date'>;
